// extracted by mini-css-extract-plugin
module.exports = {"close-button":"_1ZSur","wrapper":"_1vQCI"};